/**
 * Thrown when an instance of `AbstractFormulaNode` can't be converted
 * to an instance of `AbstractFormulaToken`. This conversion is done
 * by the `FormulaTokenizer`.
 */
export default class FormulaTokenizationError extends Error {
	constructor(node, ...rest) {
		super(...rest);

		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
		// Maintains proper stack trace for where our error was thrown
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, FormulaTokenizationError);
		}

		this.name = "FormulaTokenizationError";
		this.node = node;
	}
}
